import { useNotification } from "./useNotification";

export const useCopyToClipboard = () => {
    const notify = useNotification();
    const copyToClipboard = async (content: string, message?: string) => {
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(content);
            } else {
                // Fallback for Safari and older browsers
                const textarea = document.createElement("textarea");
                textarea.value = content;
                textarea.style.position = "fixed";
                textarea.style.opacity = "0";
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }
            notify.success(message ?? "Copied to clipboard");
        } catch (err) {
            console.error("Copy failed:", err);
            notify.error("Failed to copy to clipboard");
        }
    };

    return { copyToClipboard };
};
